import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import { ArrowUp, ArrowDown, Close } from '@sweep-io/sweep-design/dist/icons';
import { SearchInput } from '../../../../common/SearchInput';
import { useSearchContext } from './SearchContext';

export const DocumentationCardSearchInput = () => {
  const {
    searchTerm,
    arrowNavigationMatchIdx,
    totalMatches,
    isSearching,
    onSearch,
    onNext,
    onPrevious,
    onClear,
    isInputVisible,
    setIsInputVisible,
  } = useSearchContext();

  return (
    <Collapse in={isInputVisible} sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          pt: 1.5,
          position: 'relative',
          width: '100%',
          flexDirection: 'column',
        }}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <SearchInput
            TextFieldProps={{
              sx: {
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.grey[100],
                },
              },
            }}
            withFixedMagnifyingGlassIcon
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            forceCloseButton={!!searchTerm}
            onClearButtonClick={onClear}
            placeholder="Search"
            endAdornment={
              <>
                {searchTerm && totalMatches > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <Typography variant="tiny" color={colors.grey[700]} whiteSpace="nowrap">
                      {arrowNavigationMatchIdx + 1}/{totalMatches}
                    </Typography>

                    <Stack pl={0.5} direction="row" alignItems="center">
                      <IconButton
                        onClick={onPrevious}
                        disabled={arrowNavigationMatchIdx === 0}
                        size="tiny"
                        variant="flat"
                      >
                        <ArrowUp />
                      </IconButton>
                      <IconButton
                        onClick={onNext}
                        disabled={arrowNavigationMatchIdx === totalMatches - 1}
                        size="tiny"
                        variant="flat"
                      >
                        <ArrowDown />
                      </IconButton>
                    </Stack>
                  </Box>
                )}
              </>
            }
          />
          <IconButton size="tiny" variant="flat" onClick={() => setIsInputVisible(false)}>
            <Close />
          </IconButton>
        </Stack>

        <Collapse in={searchTerm !== '' && totalMatches === 0 && !isSearching}>
          <Stack pt={1}>
            <Typography variant="body" color={colors.feedback.destructive}>
              No results found
            </Typography>
          </Stack>
        </Collapse>
      </Box>
    </Collapse>
  );
};
